import { IOffer } from '../types/offer';
import { IOfferCardContext } from '../offer-card';

export const isFromSuburbanBuilder = ({dealType, kp, offerType, isResale}: IOffer): boolean =>
  dealType === 'sale' && offerType === 'suburban' && Boolean(kp) && !isResale;

export type TCommonContext = Pick<IOfferCardContext, 'offer' | 'offerHelper' | 'countrysideOffersBuilderBadge'>;

export const getIsFromBuilderFromContext = ({
  offer,
  offerHelper,
  countrysideOffersBuilderBadge,
}: TCommonContext): boolean =>
  offerHelper.isFromBuilder() || Boolean(countrysideOffersBuilderBadge && isFromSuburbanBuilder(offer));
